import AffiliateUrlAjax from '@ajax/affiliate_url';

const MAX_TRIES = 40;
const DEFAULT_RESPONSE = { is_affiliate: false, is_processed: true };

async function getResponse(responseId) {
  let resp = DEFAULT_RESPONSE;

  try {
    resp = await AffiliateUrlAjax.get(responseId, {
      withErrorHandling: false,
    });
  } catch {}

  return resp;
}

async function testUrl(url) {
  let response = DEFAULT_RESPONSE;

  try {
    response = await AffiliateUrlAjax.create(url, {
      withErrorHandling: false,
    });
  } catch {}

  if (!response || !response.id || response.is_processed === true) {
    return response;
  }

  let resp = await getResponse(response.id);

  if (resp.is_processed === true) {
    return resp;
  }

  return await checkResponse(response.id);
}

async function checkResponse(id, tries = 1) {
  const resp = await getResponse(id);

  if (resp.is_processed === true || tries > MAX_TRIES) {
    return resp;
  }

  await new Promise((resolve) => setTimeout(resolve, 500));
  return await checkResponse(id, tries + 1);
}

export default {
  testUrl,
};
